import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneActionsMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "phone-actions-menu" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.37,21.79l.01.007a4.5,4.5,0,0,0,5.6-.615l.629-.629a1.5,1.5,0,0,0,0-2.122L15.956,15.78a1.5,1.5,0,0,0-2.122,0h0a1.5,1.5,0,0,1-2.121,0L7.471,11.537a1.5,1.5,0,0,1,0-2.121h0a1.5,1.5,0,0,0,0-2.122L4.819,4.643a1.5,1.5,0,0,0-2.121,0l-.63.629a4.5,4.5,0,0,0-.614,5.6l.006.01A40.606,40.606,0,0,0,12.37,21.79Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 1.5,
			x2: 23.25,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 6,
			x2: 23.25,
			y2: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 10.5,
			x2: 23.25,
			y2: 10.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.75,
			y1: 1.5,
			x2: 14.25,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.75,
			y1: 6,
			x2: 14.25,
			y2: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.75,
			y1: 10.5,
			x2: 14.25,
			y2: 10.5
		})
	]
});
export default SvgPhoneActionsMenu;
